export const VLChatIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="24"
    fill="none"
    viewBox="0 0 32 24"
  >
    <path
      d="M0 0H6.13L12 18.12L17.9 0H24L15.61 24H8.39L0 0Z"
      fill="url(#paint0_linear_2982_7625)"
    />

    <g clip-path="url(#b)">
      <path
        fill="url(#c)"
        stroke="url(#d)"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width=".554"
        d="M29.334 6a.667.667 0 0 1 .666.667.667.667 0 0 1 .667-.667.667.667 0 0 1-.667-.667.667.667 0 0 1-.666.667ZM27 6a2 2 0 0 1 2-2 2 2 0 0 1-2-2 2 2 0 0 1-2 2 2 2 0 0 1 2 2Z"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2982_7625"
        x1="-6.84272e-08"
        y1="28.9377"
        x2="28.9068"
        y2="28.6668"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A63B94" />
        <stop offset="0.504808" stop-color="#0197D8" />
        <stop offset="1" stop-color="#18C07D" />
      </linearGradient>
      <linearGradient
        id="c"
        x1="25"
        x2="31.825"
        y1="7.627"
        y2="7.549"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A63B94" />
        <stop offset=".505" stop-color="#0197D8" />
        <stop offset="1" stop-color="#18C07D" />
      </linearGradient>
      <linearGradient
        id="d"
        x1="25"
        x2="31.825"
        y1="7.627"
        y2="7.549"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A63B94" />
        <stop offset=".505" stop-color="#0197D8" />
        <stop offset="1" stop-color="#18C07D" />
      </linearGradient>
      <clipPath id="b">
        <path fill="#fff" d="M24 0h8v8h-8z" />
      </clipPath>
    </defs>
  </svg>
);
